import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Sidebar from '../components/Sidebar';
import TopButtons from '../components/common/TopButtons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ConnectButton } from '@rainbow-me/rainbowkit';
import { useAccount, useChainId } from 'wagmi';
import { ethers } from 'ethers'; //
import CryptoJS from 'crypto-js'; 

import { useMemo } from 'react'
import { type Config, useConnectorClient } from 'wagmi'
import { clientToSigner } from '../utils/provider'; // 
import CustomModal from '../components/common/CustomModal'; 
import Loading from '../components/common/Loading'; 

import { useAnalytics } from '../hooks/useAnalytics';
import { getFactoryAddress, getInvitationAddress, getNativeToken, getLotteryAddress } from '../config/contracts';
import GameList from '../components/GameList';
import { useWalletTab } from '../context/WalletTabContext';
import { useToast } from '../contexts/ToastContext';

/** Hook to convert a viem Wallet Client to an ethers.js Signer. */
export function useEthersSigner({ chainId }: { chainId?: number } = {}) {
  const { data: client } = useConnectorClient<Config>({ chainId })
  return useMemo(() => (client ? clientToSigner(client) : undefined), [client])
}



const SALT = 'ethereum_address_salt'; 

const formatAddress = (address: string) => {
  if (address.length <= 10) return address;
  return `${address.slice(0, 10)}...${address.slice(-10)}`;
};

const HomeTopButtons = styled(TopButtons)`
`;

const WalletContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #0a0a1a;
  color: white;
  padding: 10px 10px;
  margin-left: 240px;
  
  @media (max-width: 768px) {
    margin-left: 0;
    padding-bottom: 80px;
  }
`;

const ContentWrapper = styled.div`

  margin: 10px 10px;
  width: 100%;
`;

const WalletSection = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
`;
const TabWalletSection = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  margin-bottom: 20px;
`;

const Label = styled.span`
  display: block;
  color: #4ad0ac;
  margin-bottom: 8px;
  font-size: 14px;
`;

const Value = styled.p`
  color: white;
  font-size: 16px;
  margin-bottom: 16px;
  word-break: break-all;
`;

const CopyLink = styled.span`
  color: #4ad0ac;;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

const ShareButton = styled.button`
  background: none;
  border: 1px solid #4ad0ac;
  color: #4ad0ac;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  
  &:hover {
    background: rgba(74, 208, 172, 0.1);
  }
`;

const BindButton = styled.button`
  background: #4ad0ac;
  border: none;
  border-radius: 8px;
  color: #0a0a1a;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    background: #3ab090;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 10px;
  margin-top: 20px;
  
  th {
    color: #4ad0ac;
    font-weight: normal;
    padding: 12px;
    text-align: left;
    font-size: 14px;
  }
`;

const TableBody = styled.tbody`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const TableRow = styled.tr`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  display: flex;
  
  td {
    padding: 16px;
    color: rgba(255, 255, 255);
    font-size: 14px;
    border: none;
    width: 100%;
    border-radius: 8px;
  }
`;

const ModalInput = styled.input`
  width: 95%;
  padding: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: white;
  font-size: 14px;
  margin-right: -10px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }

  &:focus {
    outline: none;
    border-color: #4ad0ac;
  }
`;

const TabContainer = styled.div`
  display: flex;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: 4px;
  margin-left: 15px;
  margin-top: 15px;
  width: fit-content;
`;

const TabButton = styled.button<{ isActive: boolean }>`
  background: ${props => props.isActive ? '#4ad0ac' : 'transparent'};
  border: none;
  border-radius: 4px;
  color: ${props => props.isActive ? '#0a0a1a' : '#4ad0ac'};
  padding: 8px 24px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    background: ${props => props.isActive ? '#4ad0ac' : 'rgba(74, 208, 172, 0.1)'};
  }
`;

const RewardsText = styled.div`
  color: #4ad0ac;
  font-size: 14px;
  margin: 20px 0;
`;

const LuckdrawContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #0a0a1a;
  color: white;
  padding: 10px 10px;
  margin-left: 240px;
  @media (max-width: 768px) {
    margin-left: 0;
    padding-bottom: 80px;
  }
`;

const Section = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
`;

const AddressList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
`;

const AddressItem = styled.li`
  color: #4ad0ac;
  font-size: 14px;
  margin-bottom: 4px;
  word-break: break-all;
`;

const Status = styled.div<{ success?: boolean }>`
  color: ${({ success }) => (success ? '#4ad0ac' : '#ff4d4f')};
  font-weight: bold;
  margin-bottom: 12px;
`;

const lotteryAbi = [
  'function getLotteryStatus() external view returns (bool, bool)',
  'function getParticipants() external view returns (address[])',
  'function getWinners() external view returns (address[])',
  'function isAddressParticipant(address) external view returns (bool)',
  'function isAddressWinner(address) external view returns (bool)'
];

const TopRow = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  @media (max-width: 900px) {
    flex-direction: column;
    gap: 0;
  }
`;

const MiddleRow = styled.div`
  display: flex;
  gap: 20px;
  @media (max-width: 900px) {
    flex-direction: column;
    gap: 0;
  }
`;

const FlexSection = styled(Section)`
  flex: 1;
  min-width: 0;
`;

const Luckdraw: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { activeTab, setActiveTab } = useWalletTab();
  const { isConnected, address } = useAccount();
  const chainId = useChainId();
  const nativeToken = getNativeToken(chainId);
  const { sendEvent } = useAnalytics();
  const signer = useEthersSigner();
  const { showToast } = useToast();
  const [lotteryStatus, setLotteryStatus] = useState<{ started: boolean; completed: boolean }>({ started: false, completed: false });
  const [participants, setParticipants] = useState<string[]>([]);
  const [winners, setWinners] = useState<string[]>([]);
  const [isParticipant, setIsParticipant] = useState<boolean>(false);
  const [isWinner, setIsWinner] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const fetchLotteryData = async () => {
      setLoading(true);
      try {
        if (!signer) return;
        const contract = new ethers.Contract(getLotteryAddress(chainId), lotteryAbi, signer);

        // 获取开奖状态
        const [started, completed] = await contract.getLotteryStatus();
        setLotteryStatus({ started, completed });

        // 获取参与者
        const participantList: string[] = await contract.getParticipants();
        setParticipants(participantList);

        // 获取中奖者
        if (completed) {
          const winnerList: string[] = await contract.getWinners();
          setWinners(winnerList);
        } else {
          setWinners([]);
        }

        // 当前钱包参与/中奖状态
        if (isConnected && address) {
          const [participant, winner] = await Promise.all([
            contract.isAddressParticipant(address),
            completed ? contract.isAddressWinner(address) : false
          ]);
          setIsParticipant(participant);
          setIsWinner(winner);
        } else {
          setIsParticipant(false);
          setIsWinner(false);
        }
      } catch (err) {
        console.error('Error fetching lottery data:', err);
      }
      setLoading(false);
    };

    fetchLotteryData();
  }, [signer, address, isConnected]);


  return (
    <>
      <Sidebar />
      <LuckdrawContainer>
      <HomeTopButtons 
        />
        <ContentWrapper>
          {/* 顶部左右布局 */}
          <TopRow>
            <FlexSection>
              <Label>{t('luckdraw.lotteryStatus')}</Label>
              <Value>
                {loading
                  ? t('luckdraw.loading')
                  : lotteryStatus.completed
                  ? t('luckdraw.completed')
                  : lotteryStatus.started
                  ? t('luckdraw.started')
                  : t('luckdraw.notStarted')}
              </Value>
            </FlexSection>
            <FlexSection>
              <Label>{t('luckdraw.yourStatus')}</Label>
              {!isConnected ? (
                <Value>{t('luckdraw.notConnected')}</Value>
              ) : (
                <>
                  <Status success={isParticipant}>
                    {isParticipant
                      ? t('luckdraw.isParticipant')
                      : t('luckdraw.notParticipant')}
                  </Status>
                  {lotteryStatus.completed && isParticipant && (
                    <Status success={isWinner}>
                      {isWinner
                        ? t('luckdraw.isWinner')
                        : t('luckdraw.notWinner')}
                    </Status>
                  )}
                </>
              )}
            </FlexSection>
          </TopRow>

          {/* 中部左右布局 */}
          <MiddleRow>
            <FlexSection>
              <Label>{t('luckdraw.participants')}</Label>
              <AddressList>
                {participants.length === 0 ? (
                  <Value>{t('luckdraw.noParticipants')}</Value>
                ) : (
                  participants.map((addr, idx) => (
                    <AddressItem key={idx}>{formatAddress(addr)}</AddressItem>
                  ))
                )}
              </AddressList>
            </FlexSection>
            <FlexSection>
              <Label>{t('luckdraw.winners')}</Label>
              <AddressList>
                {lotteryStatus.completed ? (
                  winners.length === 0 ? (
                    <Value>{t('luckdraw.noWinners')}</Value>
                  ) : (
                    winners.map((addr, idx) => (
                      <AddressItem key={idx}>{formatAddress(addr)}</AddressItem>
                    ))
                  )
                ) : (
                  <Value>{t('luckdraw.notDrawn')}</Value>
                )}
              </AddressList>
            </FlexSection>
          </MiddleRow>
        </ContentWrapper>
      </LuckdrawContainer>
    </>
  );
};

export default Luckdraw; 